import {
  ApiLinkModel,
  RichTextModel,
  SplashOnboardingStep1ElementContentModel,
  SplashOnboardingStep1PropertiesModel,
} from '@/services/platform/api/model';
import HTMLParser from 'html-react-parser';
import ModuleWrapper from '../../../../shared/module/wrapper';
import { cn, ModuleProperties, SplashContext } from '@/lib/core';
import { Button } from '@/components/ui/button';

import { StepIndicator } from '../step-indicator';
import { LinksToLinkMap } from '@/lib/core/utils/links';

export const SplashOnboardingStep1 = (props: ModuleProperties) => {
  const content = props.content as SplashOnboardingStep1ElementContentModel | undefined;

  if (!content) return null;

  const properties = content.properties as SplashOnboardingStep1PropertiesModel;

  const loginLink = LinksToLinkMap(
    (properties?.logInLink ?? undefined) as unknown as ApiLinkModel[] | undefined
  );

  const createAccountLink = LinksToLinkMap(
    (properties?.createAccountLink ?? undefined) as unknown as ApiLinkModel[] | undefined
  );

  return (
    <ModuleWrapper
      component={props}
      classNames={{
        base: cn([
          'step__onboarding-1',
          'justify-start!',
          'min-h-[calc(100vh-(env(safe-area-inset-bottom)+1.5rem))]',
        ]),
        container: cn(['flex-1']),
        wrapper: cn(['py-0', 'flex-1']),
        grid: cn(['flex', 'flex-col', 'flex-1', 'justify-between', 'gap-0']),
      }}
      isFullWidth={true}
      {...props}
    >
      <div className="flex flex-1 flex-col items-center justify-between gap-19 pt-2 pb-[calc(env(safe-area-inset-bottom)+1.5rem)]">
        {/* Step indicator */}
        <StepIndicator current={props?.index + 1} total={2} className="opacity-0" />

        {/* Body text */}
        {(loginLink || properties?.logInText) && (
          <div className="flex w-full flex-col gap-12.5 pt-60 text-center">
            {properties?.logInText && (
              <div className="font-pp-neue-montreal px-4 text-[14px] leading-[1.2] font-semibold tracking-[0.5px] text-white">
                {properties.logInText}
              </div>
            )}
            <div className="flex w-full flex-col gap-2">
              {loginLink && (
                <Button
                  variant="primary-solid"
                  palette="white"
                  size="md"
                  className="button-login w-full"
                  onClick={() => (props.context as SplashContext)?.onLogin?.()}
                >
                  {loginLink?.label}
                </Button>
              )}
              {createAccountLink && (
                <Button
                  variant="secondary-outline"
                  palette="white"
                  size="md"
                  className="button-login w-full"
                  onClick={() => (props.context as SplashContext)?.onCreateAccount?.(true)}
                >
                  {createAccountLink?.label}
                </Button>
              )}
            </div>
          </div>
        )}

        {/* Bottom actions */}
        <div className="flex w-full flex-col items-center gap-6">
          {properties?.privacyAndTerms && (
            <div className="font-pp-neue-montreal text-center text-[12px] leading-[110%] font-normal tracking-[0.5px] text-white [&_a]:font-semibold! [&_a]:underline">
              {HTMLParser((properties.privacyAndTerms as unknown as RichTextModel)?.markup ?? '')}
            </div>
          )}
        </div>
      </div>
    </ModuleWrapper>
  );
};
